import { CERoleBase } from './ce-role-base'


export class CERole extends CERoleBase {

}